import { permissionManager } from "../PermissionManager/PermissionManager";
import {
  OPEN_FILE_LOCAL,
  OPEN_FILE_FROM_GOOGLE_DRIVE,
  OPEN_FILE_FROM_DROPBOX,
  OPEN_FILE_FROM_ONE_DRIVE,
  OPEN_FILE_FROM_BOX,
  OPEN_FILE_FROM_IMANAGE,
  OPEN_IMANAGE_CLASS,
} from './openfile.constants'
import {
  SAVE_TO_LOCAL,
  SAVE_TO_ONE_DRIVE,
  SAVE_TO_BOX,
  SAVE_TO_DROPBOX,
  SAVE_TO_GOOGLE_DRIVE,
  SAVE_TO_IMANAGE,
  SAVE_TO_IMANAGE_CLASS,
  SAVE_TO_ONE_DRIVE_CLASS,
  SAVE_TO_BOX_CLASS,
  SAVE_TO_DROPBOX_CLASS,
  SAVE_TO_GOOGLE_DRIVE_CLASS,
  SAVE_TO_LOCAL_CLASS,
  SAVE_AS_FILE,
  SAVE_TO_FOXIT_STORAGE,
  SAVE_TO_FOXIT_STORAGE_CLASS,
} from './savefile.constants'
export const FILE_TAB_GROUP_FILE_OPTIMIZER = 'file-tab-group-to-optimizer';
export const FILE_TAB_TRUST_MANAGER ='file-tab-trust-manager';
export const FILE_TAB_FILE_PREFERENCES ='file-tab-preferences';
export const FILE_TAB_FILE_PROPERTIES ='file-tab-file-properties';
export const FILE_TAB_PDF_OPTIMIZER ='file-tab-pdf-optimizer';
export const FILE_TAB_PDF_REDUCE_SIZE ='file-tab-pdf-reduce-size';
export const FILE_PROPERTIES_GROUP_IN_HOME = 'file-property'
export const VIEW_TAB_COMPARE = 'view-compare-button';
export const FILE_TAB_PDF_OPTIMIZER_SCANNED = 'file-tab-pdf-optimize-scanned';
export const CREATE_NEW_ACTION = 'create-new-action';
export const RUN_ACTION = 'run-action';
export const MANAGE_ACTIONS = 'manage-actions';

export const FILE_TAB_LIST = [
    FILE_TAB_TRUST_MANAGER,
    FILE_TAB_FILE_PREFERENCES,
    FILE_TAB_FILE_PROPERTIES,
    FILE_TAB_PDF_OPTIMIZER,
    FILE_TAB_PDF_REDUCE_SIZE,
    FILE_TAB_FILE_PREFERENCES,
    FILE_TAB_PDF_OPTIMIZER_SCANNED,
    CREATE_NEW_ACTION,
    RUN_ACTION,
    MANAGE_ACTIONS
];
export const FILE_ALL_LIST = [
  OPEN_FILE_LOCAL,
  OPEN_FILE_FROM_GOOGLE_DRIVE,
  OPEN_FILE_FROM_IMANAGE,
  OPEN_FILE_FROM_DROPBOX,
  OPEN_FILE_FROM_ONE_DRIVE,
  OPEN_FILE_FROM_BOX,
  SAVE_TO_LOCAL,
  SAVE_AS_FILE,
  SAVE_TO_ONE_DRIVE,
  SAVE_TO_BOX,
  SAVE_TO_DROPBOX,
  SAVE_TO_GOOGLE_DRIVE,
  SAVE_TO_FOXIT_STORAGE,

  FILE_TAB_GROUP_FILE_OPTIMIZER,
  FILE_TAB_TRUST_MANAGER,
  FILE_TAB_FILE_PREFERENCES,
  FILE_TAB_FILE_PROPERTIES,
  FILE_TAB_PDF_OPTIMIZER,
  FILE_TAB_PDF_REDUCE_SIZE,
  FILE_PROPERTIES_GROUP_IN_HOME,
  FILE_TAB_FILE_PREFERENCES,
  FILE_TAB_PDF_OPTIMIZER_SCANNED,
  CREATE_NEW_ACTION,
  RUN_ACTION,
  MANAGE_ACTIONS
]

export const FILE_MAP = {
    openLocalFile: {
        name: OPEN_FILE_LOCAL,
        title: 'phantom_online:toolbar.buttons.openLocalFile',
        icon: 'fv__icon-toolbar-open',
    },
    openOneDrive: {
        name: OPEN_FILE_FROM_ONE_DRIVE,
        title: 'phantom_online:toolbar.buttons.openFromOneDrive',
        icon: 'fv__icon-toolbar-open-one-drive',
    },
    openBox: {
        name: OPEN_FILE_FROM_BOX,
        title: 'phantom_online:toolbar.buttons.openFromBox',
        icon: 'fv__icon-toolbar-open-box',
    },
    openDropbox: {
        name: OPEN_FILE_FROM_DROPBOX,
        title: 'phantom_online:toolbar.buttons.openFromDropBox',
        icon: 'fv__icon-toolbar-open-drop-box',
    },
    openGoogleDrive: {
        name: OPEN_FILE_FROM_GOOGLE_DRIVE,
        title: 'phantom_online:toolbar.buttons.openFromGoogleDrive',
        icon: 'fv__icon-toolbar-open-google',
    },
    openIManage: {
        name: OPEN_FILE_FROM_IMANAGE,
        title: 'phantom_online:toolbar.buttons.openFromImanage',
        icon: OPEN_IMANAGE_CLASS,
    },
    saveToLocal: {
      name: SAVE_TO_LOCAL,
      title: 'phantom_online:toolbar.buttons.saveToLocal',
      icon: SAVE_TO_LOCAL_CLASS,
    },
    saveToOneDrive: {
      name: SAVE_TO_ONE_DRIVE,
      title: 'phantom_online:toolbar.buttons.saveToOneDrive',
      icon: SAVE_TO_ONE_DRIVE_CLASS,
    },
    saveToBox: {
      name: SAVE_TO_BOX,
      title: 'phantom_online:toolbar.buttons.saveToBox',
      icon: SAVE_TO_BOX_CLASS,
    },
    saveToDropbox: {
      name: SAVE_TO_DROPBOX,
      title: 'phantom_online:toolbar.buttons.saveToDropBox',
      icon: SAVE_TO_DROPBOX_CLASS,
    },
    saveToGoogleDrive: {
      name: SAVE_TO_GOOGLE_DRIVE,
      title: 'phantom_online:toolbar.buttons.saveToGoogleDrive',
      icon: SAVE_TO_GOOGLE_DRIVE_CLASS,
    },
    saveToIManage: {
      name: SAVE_TO_IMANAGE,
      title: 'phantom_online:toolbar.buttons.saveToImanage',
      icon: SAVE_TO_IMANAGE_CLASS,
    },
    saveToFoxitStorage: {
      name: SAVE_TO_FOXIT_STORAGE,
      title: 'phantom_online:toolbar.buttons.saveToFoxitStorage',
      icon: SAVE_TO_FOXIT_STORAGE_CLASS,
    },
    trustmanager:{
        name: FILE_TAB_TRUST_MANAGER,
        title: 'phantom_online:toolbar.file.trustmanager.title',
        icon:'fv__icon-toolbar-trust-manager'
    },
    preferences:{
        name: FILE_TAB_FILE_PREFERENCES,
        title: 'phantom_online:toolbar.file.preferences.title',
        icon:'fv__icon-toolbar-preferences'
    },
    properties:{
        name:FILE_TAB_FILE_PROPERTIES,
        title:'phantom_online:toolbar.file.properties.title',
        icon: 'fv__icon-properties-info'//'fv__icon-toolbar-file-description'
    },
    optimizer:{
        name:FILE_TAB_PDF_OPTIMIZER,
        title:'phantom_online:toolbar.file.optimizer.title',
        icon:'fv__icon-toolbar-pdf-optimizer'
    },
    advancedoptimization:{
        name:FILE_TAB_PDF_OPTIMIZER,
        title:'phantom_online:toolbar.file.advancedoptimization.title',
        icon:'fv__icon-toolbar-advanced-optimization'
    },
    reduce_size:{
        name:FILE_TAB_PDF_REDUCE_SIZE,
        title:'phantom_online:toolbar.file.reducesize.title',
        icon:'fv__icon-toolbar-reduce-file-size'
    },
    optimize_scanned:{
        name:FILE_TAB_PDF_OPTIMIZER_SCANNED,
        title:'phantom_online:toolbar.file.scanned.title',
        icon:'fv__icon-toolbar-scanned-pdf'
    },
}

// premium features
export const FILE_PREMIUM_BTNS = [
  FILE_TAB_PDF_OPTIMIZER,
  FILE_TAB_PDF_REDUCE_SIZE,
  FILE_TAB_PDF_OPTIMIZER_SCANNED,
  VIEW_TAB_COMPARE,
  FILE_TAB_TRUST_MANAGER,
];
permissionManager.registerPremiumFeatures(FILE_PREMIUM_BTNS);
permissionManager.registerNotLoginFeatures([FILE_TAB_FILE_PREFERENCES]);